import React from 'react';
import { AlertStatus } from '../../types/admin';
import styles from './AlertStatusBadge.module.css';

type Variant = 'secondary' | 'success' | 'info';

const STATUS_VARIANT: Record<string, Variant> = {
  [AlertStatus.OPEN]:      'info',
  [AlertStatus.RESOLVED]:  'success',
  [AlertStatus.DISMISSED]: 'secondary',
};

const STATUS_LABEL: Record<string, string> = {
  [AlertStatus.OPEN]:      'Abierta',
  [AlertStatus.RESOLVED]:  'Resuelta',
  [AlertStatus.DISMISSED]: 'Descartada',
};

interface AlertStatusBadgeProps {
  status: AlertStatus;
}

const AlertStatusBadge: React.FC<AlertStatusBadgeProps> = ({ status }) => {
  const variant = STATUS_VARIANT[status] ?? 'secondary';
  const label   = STATUS_LABEL[status]   ?? status;

  return (
    <span className={`${styles.badge} ${styles[`badge--${variant}`]} uc-status`}>
      {label}
    </span>
  );
};

export default AlertStatusBadge;
